import PropTypes from 'prop-types';
import s from './MaterialIcon.module.scss';

const MaterialIcon = ({ name }) => {
    if (!name) {
        return null;
    }

    return <span className={s.Icon}>{name}</span>;
};

MaterialIcon.propTypes = {
    name: PropTypes.string.isRequired,
};

export default MaterialIcon;
